const eventBus = {
  on(event: string, callback: (e: Event) => void) {
    document.addEventListener(event, (e) => callback(e));
  },
  dispatch(event: string, data?: object) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove(event: string, callback: EventListenerOrEventListenerObject) {
    document.removeEventListener(event, callback);
  },
};

export default eventBus;
